module.exports = __webpack_public_path__ + "static/img/paper2.c80751b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/paper2.png
// module id = zHJs
// module chunks = 1